import React, {useState, useCallback, useRef, useEffect} from 'react'
import clsx from 'clsx'
import {type TableTabsBaseProps} from '../TableTabs.tsx'
import styles from './DropdownTabs.module.scss'
import IconArrowDown from '@static/images/icon_arrow_down.svg'
import {t} from '@colonist/ui'

export const DropdownTabs = ({className, activeTabId, tabs, onTabChange, size}: TableTabsBaseProps) => {
    const [isOpen, setIsOpen] = useState(false)
    const containerRef = useRef<HTMLDivElement>(null)
    const activeTab = tabs.find((tab) => tab.id == activeTabId)

    const handleTabChange = useCallback((tabId: string) => {
        setIsOpen(false)
        onTabChange(tabId)
    }, [onTabChange])

    useEffect(() => {
        if(!isOpen) return

        const handleClickOutside = (event: MouseEvent) => {
            if(containerRef.current && !containerRef.current.contains(event.target as Node)) setIsOpen(false)
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [isOpen])

    return (
        <div ref={containerRef} className={clsx(styles.dropdownContainer, styles[size], className)}>
            <div
                className={clsx(styles.dropdownButton, isOpen && styles.active)}
                onClick={() => setIsOpen(!isOpen)}
            >
                <span>{activeTab?.label}</span>
                <img src={IconArrowDown} alt={t('strings:imgAlts.DownArrow')} className={styles.dropdownArrow} />
            </div>
            <div
                className={clsx(styles.dropdownContents, isOpen && styles.open)}
            >
                <div className={styles.dropdownInner}>
                    {tabs.filter((tab) => tab.id != activeTabId).map((tab) => (
                        <div
                            key={tab.id}
                            className={styles.dropdownItem}
                            onClick={() => handleTabChange(tab.id)}
                        >
                            {tab.label}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
